import { Div } from './Div';
import * as DomUtil from 'leaflet/src/dom/DomUtil';

export var Combobox = Div.extend({

    initialize: function (latLngBounds, options, changeFunc) {
        Div.prototype.initialize.call(this, latLngBounds, options);
        var comboBox = DomUtil.create('select', '');
        if(changeFunc != undefined)
            comboBox.oninput = changeFunc;
        comboBox.style.width = '100%';
        comboBox.style.height = '100%';
        comboBox.style.margin = '0px';
        comboBox.style.position = 'absolute';
        comboBox.style.borderWidth = '1px';
        comboBox.style.borderRadius = '2px';
        comboBox.style.backgroundColor = options.color;
        this._elem = comboBox;
    },

    onAdd: function (map) {
        Div.prototype.onAdd.call(this, map);
        this._div.appendChild(this._elem);
    },

    _setPosition: function () {
        Div.prototype._setPosition.call(this);
        this._elem.style.fontSize = this._div.style.height;
    },

    setValue: function(newValue){
        this._elem.value = newValue;
    },

    setOptions: function(display, values){
        if(display.length !== values.length)
            throw new Error('Display and Export values must be arrays of the same length.');

        for(var i = 0; i < values.length; ++i){
            var option = DomUtil.create('option', '');
            option.text = display[i];
            option.value = values[i];
            this._elem.add(option);
        }

    },

    getValue: function(){
        return this._elem;
    }

});
